// Display labels for the demographic columns — shared by the cells and the
// column filter's checklists so both always agree.

const regionNames =
  typeof Intl !== "undefined" && "DisplayNames" in Intl
    ? new Intl.DisplayNames(["en"], { type: "region" })
    : null;

const languageNames =
  typeof Intl !== "undefined" && "DisplayNames" in Intl
    ? new Intl.DisplayNames(["en"], { type: "language" })
    : null;

/** "US" → "United States"; unknown codes fall back to the code, empty stays "". */
export function countryName(code?: string | null): string {
  if (!code) return "";
  try {
    return regionNames?.of(code.toUpperCase()) || code;
  } catch {
    return code;
  }
}

/** "en" → "English"; unknown codes fall back to the upper-cased code, empty stays "". */
export function languageLabel(code?: string | null): string {
  const normalized = (code ?? "").trim().toLowerCase();
  if (!normalized) return "";
  try {
    return languageNames?.of(normalized) ?? normalized.toUpperCase();
  } catch {
    return normalized.toUpperCase();
  }
}

/** Vet's "couldn't tell" age range (the whole 0–99 span). */
export const AGE_UNKNOWN = "0-99";

/** creator_age {min: 25, max: 34} → "25-34", the Age column's value and filter key; missing stays "". */
export function ageKey(age?: { min?: number; max?: number } | null): string {
  return age?.min != null && age?.max != null ? `${age.min}-${age.max}` : "";
}

/** "25-34" → "25–34"; "0-99" (couldn't tell) → "Not determined"; empty stays "". */
export function ageLabel(key?: string | null): string {
  if (!key) return "";
  return key === AGE_UNKNOWN ? "Not determined" : key.replace("-", "–");
}

/** Vet output "MALE" | "FEMALE" | "ANY" (couldn't tell) → label; empty stays "". */
export function genderLabel(code?: string | null): string {
  switch ((code ?? "").toUpperCase()) {
    case "MALE":
      return "Male";
    case "FEMALE":
      return "Female";
    case "ANY":
      return "Not determined";
    default:
      return "";
  }
}
